import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import { addDataLayerGAEvent } from '@common/utils/DataLayerGAHandler';

import ArrangeCallModal from './ArrangeCallModal/ArrangeCallModal';
import { servicePlansEnum } from './ServicePlans/servicePlanConfig';

const ArrangeCallHeroAddon = ({ className }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const openArrangeACallModal = () => {
    addDataLayerGAEvent('Landlord', 'openModal', 'mainMainBtn');
    setModalOpen(true);
  };

  return (
    <>
      <Button
        size="big"
        color="complementary"
        className={className}
        onClick={openArrangeACallModal}
      >
        {trans('landlord.landing.advertise-for-free.es')}
      </Button>
      <ArrangeCallModal
        isOpen={isModalOpen}
        handleModalClose={setModalOpen}
        leadType={servicePlansEnum.STANDARD}
      />
    </>
  );
};

ArrangeCallHeroAddon.propTypes = {
  className: PropTypes.string
};

ArrangeCallHeroAddon.defaultProps = {
  className: 'hero-landlord__info-cta'
};

export default ArrangeCallHeroAddon;
